import { useState } from "react";
import { Box, Collapse, useTheme, Text } from "@chakra-ui/react";
import { useAppContext } from "../../../App";

export const DropdownSimple = ({ 
  buttonText = "", 
  componentToRender,
  customStyles = {},
  componentId = '',
  futherActionsOnCLick = () => null
}) => {
  const { isMobile } = useAppContext();
  const shouldAppearOpened = ["duracion-drop","modalidades-drop","certificaciones-drop"].includes(componentId);
  const [isOpen, setIsOpen] = useState(shouldAppearOpened);
  const theme = useTheme();
  const style = styles(theme, isMobile, customStyles);
  const handleClick = () =>{
    setIsOpen(!isOpen);
    futherActionsOnCLick(componentId);
  }
  return (
    <Box id={componentId}>
      <Text 
        style={style.buttonText} 
        onClick={handleClick} cursor={'pointer'}
      >
        {buttonText}
      </Text>
      <Collapse in={isOpen} animateOpacity>
        {
          componentToRender? componentToRender() : 
          <Box mt={4} p={4} bg="white">
            Este es el contenido desplegable.
          </Box>
        }
      </Collapse>
    </Box>
  );
};


const styles = (theme, isMobile, customStyles) => ({
  buttonText: {
    ...customStyles.buttonText
  },
});
